import React from 'react';

/*

import is from 'is_js';

//Fontawesome icons
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';

//React icons
import * as BsIcons from 'react-icons/bs';
import * as LuIcons from 'react-icons/lu';

const Icons = () => {
  //Fontawesome icons
  const solids = Object.keys(fas).map(k => fas[k]);
  const brands = Object.keys(fab).map(k => fab[k]);
  const regulars = Object.keys(far).map(k => far[k]);
  const icons = [];
  for (const p in library.definitions) {
    const ics = library.definitions[p];
    for (const sp in ics) {
      icons.push([p, sp]);
    }
  }
  const fontawesomeIcons = [
    { name: 'library', icons: icons },
    { name: 'regulars', icons: regulars },
    { name: 'solids', icons: solids },
    { name: 'brands', icons: brands }
  ];

  //React icons
  const bsIconNames = Object.keys(BsIcons);
  const luIconNames = Object.keys(LuIcons);
  const reactIcons = [
    { name: 'Bootstrap Icons', names: bsIconNames, icons: BsIcons },
    { name: 'Lucide Icons', names: luIconNames, icons: LuIcons }
  ];

  return (
    <>
      {reactIcons.map((g, index) => {
        return (
          <div style={{ padding: '20px' }} key={index}>
            <h1>
              {g.name} ({g.names.length} icons)
            </h1>
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(120px, 1fr))',
                gap: '15px'
              }}
            >
              {g.names.map(name => {
                // Dynamically get the component
                const IconComponent = g.icons[name];

                return (
                  <div
                    key={name}
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      padding: '10px',
                      border: '1px solid #eee',
                      borderRadius: '8px'
                    }}
                  >
                    <IconComponent size={30} color="#563d7c" />
                    <span
                      style={{
                        fontSize: '10px',
                        marginTop: '10px',
                        wordBreak: 'break-all',
                        textAlign: 'center'
                      }}
                    >
                      {name}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
      {fontawesomeIcons.map((g, index) => {
        return (
          <div key={index}>
            <h1 className="m-3">{g.name}</h1>
            <hr></hr>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px' }}>
              {g.icons.map((icon, idx) => (
                <div key={idx} style={{ textAlign: 'center', width: '100px' }}>
                  <FontAwesomeIcon icon={icon} size="2x" />
                  <p style={{ fontSize: '10px' }}>
                    {is.array(icon)
                      ? `${icon[0]},${icon[1]}`
                      : `${icon.prefix},${icon.iconName}`}
                  </p>
                </div>
              ))}
            </div>
          </div>
        );
      })}
    </>
  );
};
*/

const Icons = () => {
  return <></>;
};
export { Icons };

export default Icons;
